export default [
  
  {
  "readingcompTitle": "Szülők egy focimeccsen",
  "topic": "szülők egy focimeccsen",
  "level": "a2",
  "image": "/Images/parents-football-match1.webp",
  "vocabulary": [
    "mérkőzés - match",
    "játékvezető - referee"
  ],
  "paragraphs": [
    {
      "text": "<p>TEXT</p>",
      "questions": [
        {
          "number": "1",
          "question": "Milyen poszton játszik Jákob?",
          "choices": [
            "A. Hátvéd",
            "B. Középpályás",
            "C. Csatár",
            "D. Kapus"
          ]
        },
        {
          "number": "2",
          "question": "Mit tanul Emese, hogy jobb legyen?",
          "choices": [
            "A. Gólt lőni",
            "B. Szerelni és passzolni",
            "C. Középpályán játszani",
            "D. Gyorsabban futni"
          ]
        }
      ]
    }
  ]
}
]
